<div class="content landing-container" *ngIf="(domain$ | async)">
    <div class="landing-file-drop-container">
        <ng-container [ngSwitch]="(rawFilesError$ | async)?.type">
            <div *ngSwitchCase="'DUPLICATE_FILES'" class="alert-message-container">
                <div class="alert-message">
                    <span translate>UPLOADER_ERROR_SAME_NAME</span>
                </div>
            </div>
            <div *ngSwitchCase="'FORBIDDEN_FILE_EXTENSION'" class="alert-message-container">
                <div class="alert-message">
                    <span translate>UPLOADER_ERROR_FORBIDDEN_FILE_EXTENSION</span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isOnDropboxRoute || (uploaderMode$ | async) === 'Transfer'; else dropboxMode">
            <app-smash-file-drop class="landing-file-drop" (fileDrop)="dropped($event)" (fileOver)="fileOver()" (fileLeave)="fileLeave()" (longpressChanged)="onLongpressChanged($event)" [directory]="isSafari">
                <ng-template #contentTemplate let-longpress="longpress" let-openFileSelector="openFileSelector"
                    let-startFolderSelector="startFolderSelector" let-cancelFolderSelector="cancelFolderSelector">
                    <div class="content-centered" (touchstart)="startFolderSelector($event)" (mousedown)="startFolderSelector($event)"
                        (mouseup)="cancelFolderSelector($event)" (touchend)="cancelFolderSelector($event)" (touchleave)="cancelFolderSelector($event)"
                        (touchcancel)="cancelFolderSelector($event)">
                        <div class="content-tooltip-wrapper">
                            <div class="content-tooltip-container">
                                <app-smash-tooltip position="top" delay="1000" displayed="true" class="smash-tooltip">
                                    <div *ngIf="isSafari" [innerHtml]="'UPLOADER_TOOLTIP_FOLDER_TEXT' | translate | safeHtml"></div>
                                    <div *ngIf="!isSafari" class="line3">
                                        <div [ngClass]="{'visible': currentTooltipState === 'in'}"
                                            [innerHtml]="'UPLOADER_TOOLTIP_FILE_TEXT' | translate | safeHtml"></div>
                                        <div [ngClass]="{'visible':  currentTooltipState === 'out'}"
                                            [innerHtml]="'UPLOADER_TOOLTIP_FOLDER_NEW_TEXT' | translate | safeHtml"></div>
                                    </div>
                                </app-smash-tooltip>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </app-smash-file-drop>
        </ng-container>
        <ng-template #dropboxMode>
            <div class="content-centered dropbox" (click)="createTeamDropbox()">
                <div class="content-tooltip-wrapper">
                    <div class="content-tooltip-container">
                        <app-smash-tooltip position="top" delay="1000" displayed="true" class="smash-tooltip">
                            <div [innerHtml]="'UPLOADER_TOOLTIP_DROPBOX_TEXT' | translate | safeHtml"></div>
                        </app-smash-tooltip>
                    </div>
                </div>
            </div>
        </ng-template>
        <div class="content-center-container">
            <app-smash-spinner 
                [waveColor]="(domain$ | async)?.logo?.waveColor"
                [url]="(theme$ | async)?.teasing?.centralLogo || (domain$ | async)?.logo?.thumbnail" 
                [borderRadius]="isOnDropboxRoute ||  (uploaderMode$ | async) === 'Transfer' ? '50%' : '30%'" 
                (click)="onSpinnerClick($event)" 
                [longpress]="longpress">
            </app-smash-spinner>
        </div>
    </div>
    <div *ngIf="(dropboxCreating$ | async)" class="dropbox-creating-spinner">
        <div class="loading-spinner-white spinner-button"></div>
    </div>
</div>